export default {
  cashback: {
    loading: true,
    balance: {
      available_cents: 0,
      pending_cents: 0,
      next_expiration_at: null,
      next_expiration_amount_cents: 0,
    },
    transactions: [],
    nextCursor: null,
    hasMore: false,
    loadingMore: false,
    totalCount: 0,
    messages: [],
  },
};
